import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=9eefc24e&scoped=true"
import script from "./Allocation.vue?vue&type=script&lang=ts"
export * from "./Allocation.vue?vue&type=script&lang=ts"
import style0 from "./Allocation.vue?vue&type=style&index=0&id=9eefc24e&prod&scoped=true&lang=css"
import style1 from "./Allocation.vue?vue&type=style&index=1&id=9eefc24e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eefc24e",
  null
  
)

export default component.exports